// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"2143":"app","9818":"auth"}[chunkId] || chunkId) + "." + {"2143":"521d284f","6002":"b3376b3a","6178":"aa526590","9663":"658dd42a","9818":"c80bd0ad"}[chunkId] + ".chunk.css";
};